import { PLG_SIGNUP_ROUTE } from "constants/routes";

// Magic-link tokens arrive as ?link=… (v2.2; ?token=… before) and must never reach analytics, Sentry or browser history.

const SENSITIVE_PARAM = /([?&]|^)((?:token|link)=)[^&#]*/gi;
const REDACTED = "%5Bredacted%5D";

/** Replaces every `token=` / `link=` query value in a URL or bare query string with "[redacted]". */
export function redactSensitiveParams(url: string): string {
  if (!url || !/(token|link)=/i.test(url)) return url;
  return url.replace(SENSITIVE_PARAM, `$1$2${REDACTED}`);
}

/** Drops the query from the address bar (keeps path, hash and the router's history state). */
export function stripTokenFromAddressBar(): void {
  const { pathname, search, hash } = window.location;
  const params = new URLSearchParams(search);
  if (!params.has("token") && !params.has("link")) return;
  window.history.replaceState(window.history.state, "", `${pathname}${hash}`);
}

// Sentry Replay and analytics record the URL the app first loads with, before React runs. The
// entry point therefore takes ?link= into memory and clears it from the address bar first; the
// sign-in page then reads it from here. Only the PLG sign-up pages (portal pages use their own ?token=).
let capturedLinkToken: string | null = null;

export function captureLinkTokenEarly(): void {
  if (window.location.pathname !== PLG_SIGNUP_ROUTE && !window.location.pathname.startsWith(`${PLG_SIGNUP_ROUTE}/`)) return;
  const link = new URLSearchParams(window.location.search).get("link");
  if (link === null) return;
  capturedLinkToken = link;
  stripTokenFromAddressBar();
}

/** The ?link= value captured at startup, handed out once. */
export function consumeCapturedLinkToken(): string | null {
  const token = capturedLinkToken;
  capturedLinkToken = null;
  return token;
}
